<template>
  <div>
    <div class="header mb-3">ข้อมูลการจอง</div>
    <div v-if="value">
      <div class="booking-info mb-3">
        <div class="title">สถานะ</div>
        <div :class="value.status" class="status-badge">{{ value.status }}</div>
      </div>
      <div class="booking-info mb-3">
        <div class="title">ชื่อ - นามสกุล</div>
        <div class="detail">{{ value.name }}</div>
      </div>
      <div class="booking-info mb-3">
        <div class="title">ชื่อบริษัท</div>
        <div class="detail">{{ value.companyName }}</div>
      </div>
      <div class="booking-info mb-3">
        <div class="title">ที่อยู่</div>
        <div class="detail">{{ value.address }}</div>
      </div>
      <div class="booking-info mb-3">
        <div class="title">อีเมล</div>
        <div class="detail">{{ value.email }}</div>
      </div>
      <div class="booking-info mb-3">
        <div class="title">เบอร์โทรศัพท์</div>
        <div class="detail">{{ value.phoneNumber }}</div>
      </div>
      <div class="booking-info">
        <div class="title">รายละเอียดกิจกรรม</div>
        <div class="detail">{{ value.eventName }}</div>
        <div class="">{{ value.eventDetail }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: null,
      default: undefined,
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
@import "~@/lib/scss/variables";

.header {
  font-size: $font-24;
  font-weight: bold;
}

.detail {
  font-size: $font-19;
  font-weight: bold;
}

.header,
.orange {
  color: $color-orange;
}

.title {
  font-size: $font-14;
  color: $color-gray;
}

.status-badge {
  display: inline-block;
  font-size: 0.9rem;
  padding: 4px 10px;
  border-radius: 4px;
  text-align: center;
  color: rgb(255, 255, 255);
  height: 30px;

  &.IN_PROCESS {
    color: $success-color;
  }

  &.DONE {
    color: $success-color;
  }

  &.PENDING {
    background-color: $secondary-color;
  }

  &.UNKNOWN {
    background-color: $danger-color;
  }

  &.CLOSE {
    background-color: $danger-color;
  }
}

@media screen and (max-width: $m-size) {
  .detail {
    font-size: $font-16;
  }
}
</style>
